<div class="pf-wrap">

  <div *ngIf="loading" class="pf-state">
    Loading navigation patterns...
  </div>

  <div *ngIf="noData && !loading" class="pf-state">
    <strong>No navigation data found for the selected filters.</strong><br>
    <span style="font-size:12px">Page flow is tracked when users navigate between screens.</span>
  </div>

  <div *ngIf="!loading && !noData && renderNodes.length"
       #flowContainer
       class="pf-chart"
       [style.height.px]="chartHeight"
       [style.min-width.px]="chartWidth">

    <!-- SVG for Sankey bands (behind cards) -->
    <svg #svgEl
         [attr.width]="chartWidth"
         [attr.height]="chartHeight"
         class="pf-svg">
    </svg>

    <!-- Column header pills -->
    <div *ngFor="let col of columnLabels; let ci = index"
         class="pf-col-label"
         [style.left.px]="colHeaderX(ci)"
         [style.width.px]="cardW">
      {{ col }}
    </div>

    <!-- Node cards rendered by Angular -->
    <div *ngFor="let node of renderNodes"
         class="pf-node"
         [style.left.px]="node.x"
         [style.top.px]="node.y"
         [style.width.px]="cardW"
         [style.height.px]="cardH"
         [style.border-left-color]="node.color">
      <div class="pf-node-name">{{ node.name }}</div>
      <div class="pf-node-count" [style.color]="node.color">
        {{ formatCount(node.count) }}<span class="pf-node-visits">visits</span>
      </div>
    </div>

  </div>
</div>
